import { IAttachmentType } from "../model/AttachmentType";
import AttachmentTypeMapper from "../service/AttachmentTypeMapper";

import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../../organisations/common/Constants";
import AttachmentTypeParamMapper from "../service/AttachmentTypeParamMapper";

export default class CreateAttachmentTypeInteractor {
  private createResource: CreateResourceInteractor<IAttachmentType>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IAttachmentType) {
    return this.createResource.execute(
      Constants.attachmentTypePath,
      AttachmentTypeMapper,
      AttachmentTypeParamMapper,
      model
    );
  }
}
